import React from "react";
import { IoSparkles } from "react-icons/io5";
import { HiSparkles } from "react-icons/hi";

const WhoAmI = () => {
  return (
    <section className="maron">
      <div className="content-container">
        <div
          className="sparkle"
          style={{ top: "20%", left: "20%", color: "#262853" }}
        >
          <HiSparkles />
        </div>
        <div
          className="sparkle"
          style={{
            top: "70%",
            right: "20%",
            color: "#051929",
            animationDelay: "200ms",
            animationDuration: "3.5s",
          }}
        >
          <HiSparkles />
        </div>
        <div
          className="sparkle"
          style={{
            top: "10%",
            right: "15%",
            color: "#171718",
            animationDelay: "500ms",
            animationDuration: "4s",
          }}
        >
          <IoSparkles />
        </div>
        <div
          className="sparkle"
          style={{
            bottom: "10%",
            left: "20%",
            animationDelay: "50ms",
            animationDuration: "5s",
          }}
        >
          <IoSparkles />
        </div>
        <div className="whoami">
          <div className="title">
            <h1>whoami</h1>
          </div>
          <div className="text">
            <p>
              <strong>
                Welcome 👋 I'm {" "}
                <span className="k-word">Haseeb Azhar</span>, but you can call me{" "}
                <span className="k-word">seeb</span>.

              </strong>
              <br />
            </p>
            <p>
              CodeNinja by day, idea builder by night. Fueled by curiosity and a passion for transforming ideas into reality.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoAmI;
